import type { GridMapboxStyle } from './styles';

export const gridsLsd = (style: GridMapboxStyle) => [
  {
    minzoom: 12,
    layout: {
      'text-field': ['get', 'label'],
      'text-size': style.textSize,
      'text-ignore-placement': false,
      'text-allow-overlap': false,
      visibility: 'visible',
    },
    type: 'symbol',
    id: 'lsd-labels',
    paint: {
      'text-color': style.textColor,
      ...(style.textHaloColor &&
        style.textHaloWidth && {
          'text-halo-color': style.textHaloColor,
          'text-halo-width': style.textHaloWidth,
        }),
    },
    source: 'grids',
    'source-layer': 'lsd_centers',
  },
  {
    minzoom: 12,
    id: 'lsd-grid',
    type: 'line',
    layout: {
      visibility: 'visible',
    },
    paint: {
      'line-color': style.lineColor,
      'line-width': style.lineWidth,
    },
    source: 'grids',
    'source-layer': 'lsd',
  },
];
